export const WEB_API = 'https://uhtpy9rxpd.execute-api.us-east-1.amazonaws.com/prod';

export const formFields = {
  confirmSignIn: {
    confirmation_code: {
      labelHidden: true,
      placeholder: 'Insira o código',
      isRequired: true,
      autoFocus: true
    },
  },
  signIn: {
    username: {
      labelHidden: true,
      placeholder: 'Insira seu email',
      isRequired: true
    },
    password: {
      labelHidden: true,
      placeholder: 'Insira sua senha',
      isRequired: true
    },
  },
  signUp: {
    email: {
      label: 'Email',
      placeholder: 'Insira seu email',
      isRequired: true
    },
    confirm_password: {
      placeholder: 'Confirme sua senha',
      isRequired: true
    },
    name: {
      label: 'Nome completo',
      placeholder: 'Insira seu nome completo',
      isRequired: true
    },
    phone_number: {
      label: 'Telefone',
      placeholder: 'Insira seu telefone',
      isRequired: true,
      dialCode: '+55'
    },
    'custom:street': {
      label: 'Rua/Logradouro',
      placeholder: 'Rua/Logradouro',
      isRequired: true
    },
    // 'custom:district': {
    //   label: 'Bairro',
    //   placeholder: 'Insira seu bairro',
    //   isRequired: true
    // },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Código',
      labelHidden: true,
      isRequired: true,
    },
    password: {
      placeholder: 'Nova senha',
      labelHidden: true,
      isRequired: true,
    },
    confirm_password: {
      placeholder: 'Confirmar senha',
      labelHidden: true,
      isRequired: true,
    }
  },
  forceNewPassword: {
    password: {
      placeholder: 'Nova senha',
      labelHidden: true,
      isRequired: true,
    },
    confirm_password: {
      placeholder: 'Confirmar senha',
      labelHidden: true,
      isRequired: true,
    },
    name: {
      labelHidden: true,
      placeholder: 'Nome',
      isRequired: true
    }
  },
  forgotPassword: {
    username: {
      label: 'Insira seu email',
      placeholder: 'Insira seu email',
      isRequired: true,
    }
  }
}